import React from 'react';
import type { CountryOptionProps } from '@components/moleculs/country-option/types';
import { Box, Checkbox } from '@mui/material';
import cn from 'classnames';
import { styled } from 'styled-components';

import { CountryFlag } from '../country-flag';

const Molecule: React.FC<CountryOptionProps> = ({
    option,
    selected,
    className,
    isShowCheckbox = true,
    compact = false,
    disabled = false,
    disabledSuffix,
    ...rest
}) => (
    <Box className={cn(className, { 'country-option-checkbox': compact })} component='li' {...rest}>
        {isShowCheckbox && <Checkbox checked={selected} />}
        <CountryFlag name={option.value} />
        <Box
            sx={{
                marginLeft: '8px',
            }}
        >
            {option.label}
            {disabled && disabledSuffix}
        </Box>
    </Box>
);

export const CountryOption = styled(Molecule)({});
